<template>
    <section>
        <o-field label="Success">
            <o-steps variant="success">
                <o-step-item label="Account" icon="user-lock" clickable />
                <o-step-item label="Profile" icon="user" clickable />
                <o-step-item label="Social" icon="user-plus" clickable />
            </o-steps>
        </o-field>

        <o-field label="Info">
            <o-steps variant="info">
                <o-step-item label="Account" icon="user-lock" clickable />
                <o-step-item label="Profile" icon="user" clickable />
                <o-step-item label="Social" icon="user-plus" clickable />
            </o-steps>
        </o-field>

        <o-field label="Warning">
            <o-steps variant="warning">
                <o-step-item label="Account" icon="user-lock" clickable />
                <o-step-item label="Profile" icon="user" clickable />
                <o-step-item label="Social" icon="user-plus" clickable />
            </o-steps>
        </o-field>

        <o-field label="Danger">
            <o-steps variant="danger">
                <o-step-item label="Account" icon="user-lock" clickable />
                <o-step-item label="Profile" icon="user" clickable />
                <o-step-item label="Social" icon="user-plus" clickable />
            </o-steps>
        </o-field>
    </section>
</template>
